if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                this.cart.renderContents(response);

                // Auto-open cart drawer after adding item (like collection product cards)
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  setTimeout(() => {
                    cartDrawer.open();
                  }, 100);
                }

                // Update sticky cart count immediately
                if (typeof window.updateStickyCart === 'function') {
                  window.updateStickyCart();
                }
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);

            // Update all cart icons and counts immediately
            this.updateCartIcons();

            // Auto-open cart drawer after adding item (like collection product cards)
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              setTimeout(() => {
                cartDrawer.open();
              }, 100);
            }

            // Update sticky cart count immediately
            if (typeof window.updateStickyCart === 'function') {
              window.updateStickyCart();
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');

            // Add success animation like collection product cards
            const originalText = this.submitButton.querySelector('span').textContent;
            this.submitButton.querySelector('span').textContent = 'Added!';
            this.submitButton.classList.add('success');

            setTimeout(() => {
              this.submitButton.querySelector('span').textContent = originalText;
              this.submitButton.classList.remove('success');
            }, 2000);
          }
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    updateCartIcons() {
      // Update cart icon bubble via section rendering
      fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble) {
            cartIconBubble.innerHTML = html.querySelector('.shopify-section').innerHTML;
          }
        })
        .catch(e => {
          console.error('Error updating cart icon bubble:', e);
        });

      // Update cart count via cart.js API for immediate feedback
      fetch(`${routes.cart_url}.js`)
        .then(response => response.json())
        .then(cart => {
          // Update all cart count elements
          const cartCountElements = document.querySelectorAll(
            '[data-cart-count], .cart-count, #sticky-cart-count, .cart-count-bubble, .tcg-badge, .mobile-header__cart-count'
          );
          cartCountElements.forEach(element => {
            element.textContent = cart.item_count;

            // Add update animation
            element.classList.add('cart-updated');
            setTimeout(() => {
              element.classList.remove('cart-updated');
            }, 300);
          });

          // Show/hide cart count based on items
          cartCountElements.forEach(element => {
            if (cart.item_count === 0) {
              element.style.display = 'none';
            } else {
              element.style.display = '';
            }
          });

          // Trigger custom cart update event
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart, source: 'product-form' }
          }));
        })
        .catch(e => {
          console.error('Error updating cart count:', e);
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
